import { ResponseError } from '@marketplace-web/core-api/api-client-util'
import { api } from '@marketplace-web/core-api/core-api-client-util'

import {
  createLiveChatTicketArgsToParams,
  CreateLiveChatTicketArgs,
  CreateLiveChatTicketResp,
  LiveChatAvailabilityResp,
} from '../types/live-chat'

export const getLiveChatAvailability = (
  transactionId: number,
): Promise<LiveChatAvailabilityResp | ResponseError> =>
  api.get<LiveChatAvailabilityResp, ResponseError>(
    `/help_center/live_chat_status?transaction_id=${transactionId}`,
  )

export const createLiveChatTicket = (args: CreateLiveChatTicketArgs) =>
  api.post<CreateLiveChatTicketResp, ResponseError>(
    '/help_center/live_chat_ticket',
    createLiveChatTicketArgsToParams(args),
  )
